
import constants from 'Constants.js';

// import property view references here
import MainNameView from 'properties/MainNameView.js';
import mainFormNameView from 'properties/main/MainFormNameView.js';
import MainHtmlAlignmentView from 'properties/main/MainHtmlAlignmentView.js';
import MainTextAlignmentView from 'properties/main/MainTextAlignmentView.js';
import MainMaxCharsView from 'properties/main/MainMaxCharsView.js';
import MainFormatView from 'properties/main/MainFormatView.js';
import MainPictureView from 'properties/main/MainPictureView.js';
import MainTextView from 'properties/MainTextView.js';
import mainDropDownView from 'properties/main/MainDropDownView.js';
import mainListItemView from 'properties/main/MainListItemView.js';

import mainLengthView from 'properties/main/MainLengthView.js';
import mainHeaderView from 'properties/main/MainHeaderView.js';
import mainButtonTypeView from 'properties/main/MainButtonTypeView';
import printFileNameView from 'properties/main/PrintFileNameView';

import mainCaptionView from 'properties/main/MainCaptionView.js';
import MainNumberView from 'properties/main/MainNumberView.js';
import mainPasswordView from 'properties/main/MainPasswordView.js';
import mainDateValueView from 'properties/main/MainDateValueView.js';
import mainCalendarValueView from 'properties/main/MainCalendarValueView.js';
import mainTimeValueView from 'properties/main/MainTimeValueView.js';
import mainFileSizeView from 'properties/main/MainFileSizeView.js';
import mainButtonLabelsView from 'properties/main/MainButtonLabelsView.js';
import MainImageButtonLabelsView from 'properties/main/MainImageButtonLabelsView';
import MainImageButtonPositionView from 'properties/main/MainImageButtonPositionView.js';
import mainButtonPositionView from 'properties/main/MainButtonPositionView.js';
import mainMaskView from 'properties/main/MainMaskView.js';
import mainTimerView from 'properties/main/MainTimerView.js';
import mainAutoStartView from 'properties/main/MainAutoStartView.js';
import mainNumericView from 'properties/main/MainNumericView.js';
import MainTableColumnsView from 'properties/main/MainTableColumnsView.js';
import mainFileTypesView from 'properties/main/MainFileTypesView.js';
import MainLabelView from 'properties/main/MainLabelView.js';
import MainProgressView from 'properties/main/MainProgressView.js';
import mainSizeView from 'properties/main/MainSizeView.js';
import mainInstanceNameView from 'properties/main/MainInstanceNameView.js';
import MainUrlView from 'properties/main/MainUrlView.js';
import MainRankingView from 'properties/main/MainRankingView.js';
import MainPageView from 'properties/main/MainPageView.js';
import MainSliderView from 'properties/main/MainSliderView.js';
import MainSliderCaptionsView from 'properties/main/MainSliderCaptionsView.js';
import MainFormInstanceView from 'properties/main/MainFormInstanceView.js';
import MainMiscFormReportView from 'properties/main/MainMiscFormReportView.js';
import MainCustomParametersView from 'properties/main/MainCustomParametersView.js';
import MainAssetNameView from 'properties/main/MainAssetNameView.js';
import MainAssetPreviewView from 'properties/main/MainAssetPreviewView.js';
import MainMandatoryView from 'properties/main/MainMandatoryView.js';
import MainEncryptView from 'properties/main/MainEncryptView.js';
import MainInputPurposeAutofillView from 'properties/main/MainInputPurposeAutofillView.js';
import MainTargetView from 'properties/main/MainTargetView.js';
import MainCheckboxView from 'properties/main/MainCheckboxValueView.js'
import MainRadioButtonView from 'properties/main/MainRadioButtonValueView.js'
import MainTableConfigView from 'properties/main/MainTableConfigView.js'
import MainShowSuccessView from 'properties/main/MainShowSuccessView';
import MainSubmitAsChildView from 'properties/main/MainSubmitAsChildView';
import MainAfterSubmissionView from 'properties/main/MainAfterSubmissionView';
import MainSoundView from 'properties/main/MainSoundView.js';
import MainMovieView from 'properties/main/MainMovieView.js';
import mainSelectFormOrReportView from 'properties/main/MainSelectFormOrReportView.js';
import mainSelectFormFieldView from 'behaviors/properties/main/MainSelectFormFieldView.js';
import MainSharedSettingsLinkView from 'properties/main/MainSharedSettingsLinkView.js';
import NavTooltipView from 'properties/navigation/NavTooltipView.js'
import MainTableRowsView from 'properties/main/MainTableRowsView.js';
import StyleHeaderFontView from 'properties/style/StyleHeaderFontView.js'
import testDescriptionView from 'properties/TestDescriptionView';
import MainAutocomplete from 'properties/main/MainAutocomplete.js';

//Mobile
import MobileMainMarginsView from 'properties/main/MobileMainMarginsView.js';
import MobileMainFormView from 'properties/main/MobileMainFormView.js';
import mobileConstants from '../mobile/commons/MobileFormsConstants'

//behaviour main
import MainAutoSummaryView from 'behaviors/properties/main/MainAutoSummaryView.js';
import MainExitView from 'behaviors/properties/main/MainExitView.js';
import MainCancellationView from 'behaviors/properties/main/MainCancellationView.js';
import MainConditionView from 'behaviors/properties/main/MainConditionView.js';
import MainFunctionView from 'behaviors/properties/main/MainFunctionView.js';
import MainRedirectURL from 'behaviors/properties/main/MainRedirectURL.js';
import MainSelectPage from 'behaviors/properties/main/MainSelectPage.js';
import MainSelectObject from 'behaviors/properties/main/MainSelectObjectView.js';
import SetProperty from 'behaviors/properties/main/SetPropertyView.js';
import BehaviorInstanceView from 'behaviors/properties/main/BehaviorInstanceView.js';
import ConnectorView from 'behaviors/properties/main/ConnectorView.js';
import MainSelectBehaviorView from 'behaviors/properties/main/MainSelectBehaviorView.js';
import mainReportMiscView from 'behaviors/properties/main/MainReportMiscView.js';

//workflow name
import MainStageWorkflowView from 'workflow/properties/main/MainStageWorkflowView.js';
import MainCommentWorkflowView from 'workflow/properties/main/MainCommentWorkflowView.js';
import MainParametersView from 'behaviors/properties/main/MainParametersView.js';
import MainReturnValueTargetView from 'behaviors/properties/main/MainReturnValueTargetView.js';
import MainCloseView from 'behaviors/properties/main/MainCloseView.js';
import MainCheckMandatorySettings from 'behaviors/properties/main/MainCheckMandatorySettings.js';
import MainCommentView from 'behaviors/properties/main/MainCommentView.js';
import MainConnectView from 'behaviors/properties/main/MainConnectView.js';
import MainSendView from 'behaviors/properties/main/MainSendView.js';
import MainReturnView from 'behaviors/properties/main/MainReturnView.js';
import MainCopyFieldsView from 'behaviors/properties/main/MainCopyFieldsView.js';
import MainSetSelectionItemsView from 'behaviors/properties/main/MainSetSelectionItemsView.js';
import MainGetFieldFromView from 'behaviors/properties/main/MainGetFieldFromView.js';
import MainNotifyView from 'behaviors/properties/main/MainNotifyView.js';
import MainShowReportView from 'behaviors/properties/main/MainShowReportView.js';
import MainTitleView from 'behaviors/properties/main/MainTitleView.js';
import SelectValuePropertyView from 'common-views/properties/SelectValuePropertyView.js'
import MessageTypeView from 'behaviors/properties/main/MessageTypeView.js';
import MainShowFormView from 'behaviors/properties/main/MainShowFormView.js';
import MainInstanceNameView from 'behaviors/properties/main/MainInstanceNameView.js';
import MainPrintView from 'behaviors/properties/main/MainPrintView.js';
import MainObjectStatesView from 'behaviors/properties/main/MainObjectStatesView.js';
import MainStartStopView from 'behaviors/properties/main/MainStartStopView.js';
import MainBrowserWindowView from 'behaviors/properties/main/MainBrowserWindowView.js';
import MainSetFieldView from 'behaviors/properties/main/MainSetFieldView.js';
import MainConfirmationView from 'behaviors/properties/main/MainConfirmationView.js';
import MainNextStageView from 'behaviors/properties/main/MainNextStageView.js';
import MainTableActionView from 'behaviors/properties/main/MainTableActionView.js';
import MainTypeView from 'behaviors/properties/main/MainTypeView.js';
import MainTransactionView from 'behaviors/properties/main/MainTransactionView.js';
import PathView from 'workflow/properties/main/PathView.js';
import MainDescriptionView from 'workflow/properties/main/MainDescriptionView.js';
import MainStageDescriptionView from 'workflow/properties/main/MainStageDescriptionView.js';

//reports
import MainLineChartTypeView from 'report/properties/main/MainLineChartTypeView.js';
import MainChartAxesView from 'report/properties/main/MainChartAxesView.js';
import MainChartDataView from 'report/properties/main/MainChartDataView.js';
import MainValueView from 'report/properties/main/MainValueView.js';
import MainDataView from 'report/properties/main/MainDataView.js';
import MainChartFieldsView from 'report/properties/main/MainChartFieldsView.js';
import MainChartFieldView from 'report/properties/main/MainChartFieldView.js';
import MainChartSortView from 'report/properties/main/MainChartSortView.js';
import MainChartFilterView from 'report/properties/main/MainChartFilterView.js';
import MainChartMiscAccesibilityView from 'report/properties/main/MainChartMiscAccessibilityView.js';
import StylePieSliceView from 'report/properties/style/StylePieSliceView.js';
import StyleGraphColorView from 'report/properties/style/StyleGraphColorView.js';
import MainDataSources from 'report/properties/main/MainDataSourcesView.js';
import MainCrosstabColumnsView from 'report/properties/main/MainCrosstabColumnsView.js';
import MainDataSourceView from 'report/properties/main/MainDataSourceView.js';
import MainFilterTypeView from 'report/properties/main/MainFilterTypeView.js';
import MainFieldView from 'report/properties/main/MainFieldView.js';
import MainFieldTypeView from 'report/properties/main/MainFieldTypeView.js';
import MainFilterOverrideView from 'report/properties/main/MainFilterOverrideView.js';
import MainPieChartLabelView from 'report/properties/main/MainPieChartLabelView.js';
import MainFilterView from 'report/properties/main/MainFilterView.js';
import MainOperatorView from 'report/properties/main/MainOperatorView.js';


import MainChartScaleView from 'report/properties/main/MainChartScaleView.js';
import StyleGaugeNeedleView from 'report/properties/style/StyleGaugeNeedleView.js';
import StyleGaugeBackgroundView from 'report/properties/style/StyleGaugeBackgroundView.js';

import ColumnMainNameView from 'properties/table/MainNameView.js';
import ColumnMainColumnView from 'properties/table/MainColumnView.js';
import ColumnMainTextView from 'properties/table/MainTextView.js';
import ColumnMainDateValueView from 'properties/table/MainDateValueView.js';
import ColumnMainCheckboxView from 'properties/table/MainColumnCheckboxView.js';
import ColumnMainNumberView from 'properties/table/MainNumberView.js';
import ColumnMainTimeValueView from 'properties/table/MainTimeValueView.js';
import ColumnMainDropDownView from 'properties/table/MainDropDownView.js';

import ColumnMainFileSizeView from 'properties/table/MainFileSizeView.js';
import ColumnMainButtonLabelView from 'properties/table/MainButtonLabelView';
import ColumnMainFileButtonPositionView from 'properties/table/MainFileButtonPositionView.js';
import ColumnMainFileTypesView from 'properties/table/MainFileTypesView.js';
import ColumnMainCaptionView from 'properties/table/MainCaptionView.js';
import ColumnMainFormSelectView from 'properties/table/MainFormSelectView.js';
import ColumnMainCustomParametersView from 'properties/table/MainCustomParametersView.js';
import ColumnMainMiscView from 'properties/table/MainMiscView.js';
import ColumnAccessStateView from 'properties/table/ColumnAccessStateView.js';
import ColumnAccessHiddenView from 'properties/table/ColumnAccessHiddenView.js';
import ColumnMandatoryView from 'properties/table/ColumnMandatoryView.js';


import StyleTextView from 'properties/style/StyleTextView.js';
import StyleLabelView from 'properties/style/StyleLabelView.js';
import StyleBarView from 'properties/style/StyleBarView.js';
import StyleFontView from 'properties/style/StyleFontView.js';
import StyleTextStyleView from 'properties/style/StyleTextStyleView.js';
import StyleTextColorView from 'properties/style/StyleTextColorView.js';
import StyleBackgroundColorView from 'properties/style/StyleBackgroundColorView.js';
import StyleHeaderBGColorView from 'properties/style/StyleHeaderBGColorView.js';
import StyleBackgroundView from 'properties/style/StyleBackgroundView.js';
import StyleBackgroundClearFilterView from 'properties/style/StyleBackgroundClearFilterView.js';
import StyleBackgroundGradientColor from 'properties/style/StyleBackgroundGradientColor.js';
import StyleBackgroundPictureView from 'properties/style/StyleBackgroundPictureView.js';
import StyleAdvancedBackgroundColorView from 'properties/style/StyleAdvancedBackgroundColorView.js';
import StyleBorderView from 'properties/style/StyleBorderView.js';
import StyleAdvancedBorderView from 'properties/style/StyleAdvancedBorderView.js';
import StyleScrollbarsView from 'properties/style/StyleScrollbarsView.js';
import StyleCaptionView from 'properties/style/StyleCaptionView.js';
import StyleColorsView from 'properties/style/StyleColorsView.js'
import StyleLineView from 'properties/style/StyleLineView.js';
import StyleMouseOverView from 'properties/style/StyleMouseOverView.js';
import ColumnStyleTextView from 'properties/table/StyleTextView.js';
import ColumnStyleBackgroundView from 'properties/table/StyleBackgroundView.js';
import ColumnStyleBorderSimpleView from 'properties/table/StyleBorderSimpleView.js';
import ColumnStyleCaptionView from 'properties/table/StyleCaptionView.js';
import ColumnStyleButtonBackgroundView from 'properties/table/StyleButtonBackgroundView.js';
import ColumnStyleBorderView from 'properties/table/StyleBorderView.js';
import ColumnStyleButtonView from 'properties/table/StyleButtonView.js';

import styleFrameView from 'properties/style/StyleFrameView.js';
import styleGridView from 'properties/style/StyleGridView.js';
import stylePageTurningView from 'properties/style/StylePageTurningView.js'
import styleScreenView from 'properties/style/StyleScreenView.js';
import StyleSliderScaleView from 'properties/style/StyleSliderScaleView.js';
import StyleSignatureColorAndThicknessView from 'properties/style/StyleSignatureColorAndThicknessView.js';
import StyleImageBackgroundView from 'properties/style/StyleImageBackgroundView.js';
import StyleSignatureButtonBackgroundView from 'properties/style/StyleSignatureButtonBackgroundView.js';
import StylesThemeResetView from 'properties/style/StyleThemeResetView.js';
import StyleBackgroundButtonView from 'properties/style/StyleBackgroundButtonView.js';
import StyleTableHeaderTextView from 'properties/style/StyleTableHeaderTextView.js';
import StyleTableHeaderBackgroundView from 'properties/style/StyleTableHeaderBackgroundView.js';
import StyleTableRowTextView from 'properties/style/StyleTableRowTextView.js';
import StyleTableRowsBackgroundView  from 'properties/style/StyleTableRowsBackgroundView.js';
import StyleButtonFontView from 'properties/style/StyleButtonFontView'

import AccessibilityView from 'properties/AccessibilityView.js';
import NavPositionView from 'properties/navigation/NavPositionView.js';
import NavTabbingView from 'properties/navigation/NavTabbingView.js';
import NavAccessSilent from 'properties/navigation/NavAccessSilentView.js';
import NavAccessDescriptionView from 'properties/navigation/NavAccessDescriptionView.js';
import NavAccessHiddenView from 'properties/navigation/NavAccessHiddenView.js';
import NavAccessStateView from 'properties/navigation/NavAccessStateView.js';

import PagesView from 'properties/advanced/PagesView.js';
import SectionsView from 'properties/advanced/SectionsView.js';
import locationView from 'properties/advanced/LocationView.js';
import appAccessibilityView from 'properties/accessibility/AppAccessibilityView.js';
import lockingView from 'properties/advanced/LockingView.js';
import ViewingView from 'properties/advanced/ViewingView.js';
import AppendixSizeView from 'properties/advanced/AppendixSizeView.js';
import multilanguageView from 'properties/advanced/MultilanguageView.js';
import advancedCSSView from 'properties/advanced/AdvancedCSSView.js';
import exportImportTheme from 'properties/theme/ExportImportView.js'

import themePagesView from 'properties/theme/PageView.js';
import themeTextsView from 'properties/theme/TextsView.js';
import themeInputsView from 'properties/theme/InputsView.js';
import themeButtonsView from 'properties/theme/ButtonsView.js';
import themeCheckboxesView from 'properties/theme/CheckboxesView.js';
import themeGroupsView from 'properties/theme/GroupsView.js';
import themeTablesView from 'properties/theme/TablesView.js';
import themeMiscView from 'properties/theme/MiscView.js';

// Workflow view mapping imports.
import mainFormStatusView from '../views/workflow/properties/main/MainFormStatusView.js';
import RolesView from '../views/workflow/properties/roles/RolesView.js';




//==================================================================
// Developers populate each array with view class names for the
// given control.
//
// Note: only a class name, not a class instance, appears in each
// array elemement. Each needs an import above.
//==================================================================

    const accessRoot = {
        'control_crosstab': [
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_data_grid': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_data_list': [
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_bar_chart': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_filter_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_clear_filter_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_pie_chart': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_value': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_gauge_chart': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],

        'control_filter_selector': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_line_chart': [
            {view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_text': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_small_text': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_large_heading': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_medium_heading': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_small_heading': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_picture': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_submit_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_page_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_group': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_bullet_text': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_vertical_separator': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_horizontal_separator': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_sound': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN}
        ],
        'control_movie': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_link': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_progress_bar': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_print_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_timer': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN}
        ],
        'control_captcha': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_text_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_multiple_text_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_numeric_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_date_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_time_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_date_calendar': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_checkbox': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_checkbox_group': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_radio_button_group': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_radio_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN}
        ],
        'control_list': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_drop_down': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_numeric_stepper': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_mask_text_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_password_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_file_attachment': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_image_input': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_websignature': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_vertical_slider': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_horizontal_slider': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_table': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'textInputColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'buttonColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'checkboxColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'childFormColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],

        'dateInputColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'dropdownColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'fileAttachmentColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'numericInputColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'radioButtonColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'textAreaColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'timeInputColumn':  [{view: ColumnAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: ColumnAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_ranking':[{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_play_form_button':[{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'control_play_report_button': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ],
        'layout_frame': [{view: ViewingView, el: constants.PROP_ACCESS_STATE}
        ],
        'page_instance': [{view: NavAccessHiddenView, el: constants.PROP_ACCESS_HIDDEN},
            {view: NavAccessStateView, el: constants.PROP_ACCESS_STATE}
        ]
    };

    const settingsRoot = {
        'control_hello_world': [{view: testDescriptionView, el: constants.PROP_MAIN_VALUE}],
        'control_bar_chart': [
            {view: MainChartAxesView, el: constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.PROP_MAIN_CHART_FILTER},
            {view: MainChartMiscAccesibilityView, el: constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_crosstab': [
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainCrosstabColumnsView, el: constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartFilterView, el: constants.PROP_MAIN_CHART_FILTER},
            {view: MainChartMiscAccesibilityView, el: constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING}
        ],
        'control_filter_selector': [
            {view: MainFieldTypeView, el: constants.PROP_MAIN_FIELD_TYPE},
            {view: MainDataSourceView, el: constants.PROP_MAIN_DATA_SOURCE_SINGLE},
            {view: MainFieldView, el: constants.PROP_MAIN_FIELD},
            {view: MainFilterView, el: constants.PROP_MAIN_FILTER_OVERRIDE},
            {view: MainChartFilterView, el: constants.PROP_MAIN_FILTER},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_gauge_chart': [
            {view: MainChartScaleView, el: constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldView, el: constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartFilterView, el: constants.PROP_MAIN_CHART_FILTER},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_clear_filter_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MainDataSourceView, el: constants.PROP_MAIN_DATA_SOURCE_SINGLE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_filter_input': [
            {view: MainFilterTypeView, el: constants.PROP_MAIN_FILTER_TYPE},
            {view: MainDataSourceView, el: constants.PROP_MAIN_DATA_SOURCE_SINGLE},
            {view: MainFieldView, el: constants.PROP_MAIN_FIELD},
            {view: MainFilterOverrideView, el: constants.PROP_MAIN_FILTER_OVERRIDE},           
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_value': [
            {view: MainDataSourceView, el: constants.PROP_MAIN_DATA_SOURCE_SINGLE},
            {view: MainValueView, el: constants.PROP_MAIN_VALUE},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_text': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_small_text': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_large_heading': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_line_chart': [
            {view: MainLineChartTypeView, el: constants.PROP_MAIN_DROPDOWN},
            {view: MainChartAxesView, el: constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.PROP_MAIN_CHART_FILTER},
            {view: MainChartMiscAccesibilityView, el: constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_medium_heading': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_small_heading': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_picture': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainPictureView, el: constants.PROP_MAIN_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_pie_chart': [
            {view: MainPieChartLabelView, el: constants.PROP_MAIN_REPORT_SETTINGS},
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.PROP_MAIN_CHART_FILTER},
            /*{view: MainChartMiscAccesibilityView, el: constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},*/
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_submit_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MainShowSuccessView, el: constants.PROP_MAIN_SHOW_SUCCESS},
            {view: MainSubmitAsChildView, el: constants.PROP_MAIN_SUBMIT_AS_CHILD},
            {view: MainAfterSubmissionView, el: constants.PROP_MAIN_AFTER_SUBMISSION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            //{view:MainUrlView, el: constants.PROP_MAIN_URL},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_FORM_INSTANCE,
                config: {viewTitle: "Redirect Url", modelField: "default"}
            },
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_page_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: MainPageView, el: constants.PROP_MAIN_PAGE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_group': [{view: mainHeaderView, el: constants.PROP_MAIN_HEADER},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}],
        'control_bullet_text': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'control_vertical_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_horizontal_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_sound': [
            {view: MainSoundView, el: constants.PROP_MEDIA_SETTINGS, config: {hideTitle: true}}
        ],
        'control_movie': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: MainMovieView, el: constants.PROP_MEDIA_SETTINGS, config: {hideTitle: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_link': [
            //{view:MainUrlView, el: constants.PROP_MAIN_URL},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_FORM_INSTANCE,
                config: {viewTitle: "Redirect URL", modelField: "default"}
            },
            {view: MainTargetView, el: constants.PROP_MAIN_TARGET},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.PROP_ACCESS_SILENT}
        ],
        'control_progress_bar': [
            {view: MainProgressView, el: constants.PROP_MAIN_PROGRESS, config: {hideTitle: true}},
            {view: MainLabelView, el: constants.PROP_MAIN_LABEL},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_print_button': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: printFileNameView, el: constants.PROP_PRINT_FILE_NAME},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: PagesView, el: constants.PROP_MAIN_PAGE},
            {view: SectionsView, el: constants.PROP_SECTIONS},
            {view: AppendixSizeView, el: constants.PROP_APPENDIX_SIZE_VIEW}
        ],
        'control_timer': [{view: mainTimerView, el: constants.PROP_MAIN_TIMER},
            {view: mainAutoStartView, el: constants.PROP_MAIN_AUTO_START}
        ],
        'control_captcha': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: mainLengthView, el: constants.PROP_MAIN_LENGTH}
        ],
        'control_text_input': [
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.PROP_MAIN_ENCRYPT},
            {view: MainAutocomplete, el: constants.PROP_MAIN_AUTOCOMPLETE},
             {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
             {view: MainFormatView, el: constants.PROP_MAIN_TEXT_FORMAT},
             {view: MainTextAlignmentView, el: constants.PROP_MAIN_TEXT_ALIGNMENT},
             {view: MainMaxCharsView, el: constants.PROP_MAIN_MAX_CHARS}
             
        ],
        'control_multiple_text_input': [
            {view: MainAutocomplete, el: constants.PROP_MAIN_AUTOCOMPLETE},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: MainMaxCharsView, el: constants.PROP_MAIN_MAX_CHARS},
            {view: StyleScrollbarsView, el: constants.PROP_STYLE_SCROLLBARS}
            
        ],
        'control_numeric_input': [
            {view: mainNumericView, el: constants.PROP_MAIN_NUMBER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_date_input': [
            {view: mainDateValueView, el: constants.PROP_MAIN_DATE_VALUE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_time_input': [{view: mainTimeValueView, el: constants.PROP_MAIN_TIME_VALUE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_date_calendar': [{view: mainCalendarValueView, el: constants.PROP_MAIN_CALENDAR_VALUE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_checkbox': [{view: MainCheckboxView, el: constants.PROP_MAIN_CHECKBOX_VALUE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_checkbox_group': [{view: mainHeaderView, el: constants.PROP_MAIN_HEADER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_radio_button_group': [{view: mainHeaderView, el: constants.PROP_MAIN_HEADER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_radio_button': [{view: MainRadioButtonView, el: constants.PROP_MAIN_RADIO_BUTTON_VALUE},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_list': [
            {view: mainListItemView, el: constants.PROP_MAIN_LIST_ITEM},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY}
        ],
        'control_data_grid': [{view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_data_list': [{view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_drop_down': [{view: mainDropDownView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY}
        ],
        'control_numeric_stepper': [{view: MainNumberView, el: constants.PROP_MAIN_NUMBER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_mask_text_input': [{view: mainMaskView, el: constants.PROP_MAIN_MASK},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_password_input': [{view: mainPasswordView, el: constants.PROP_MAIN_PASSWORD},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_file_attachment': [{view: mainFileSizeView, el: constants.PROP_MAIN_FILE_SIZE},
            {view: mainFileTypesView, el: constants.PROP_MAIN_FILE_TYPES},
            {view: mainButtonLabelsView, el: constants.PROP_MAIN_BUTTON_LABELS},
            {view: mainButtonPositionView, el: constants.PROP_MAIN_BUTTON_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'control_image_input': [{view: mainFileSizeView, el: constants.PROP_MAIN_FILE_SIZE},
            {view: MainImageButtonLabelsView, el: constants.PROP_MAIN_BUTTON_LABELS},
            {view: MainImageButtonPositionView, el: constants.PROP_MAIN_BUTTON_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_websignature': [
            {view: mainButtonLabelsView, el: constants.PROP_MAIN_BUTTON_LABELS},
            {view: mainButtonPositionView, el: constants.PROP_MAIN_BUTTON_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_vertical_slider': [
            {view: MainSliderView, el: constants.PROP_MAIN_SLIDER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainSliderCaptionsView, el: constants.PROP_MAIN_SLIDER_CAPTIONS}
        ],
        'control_horizontal_slider': [
            {view: MainSliderView, el: constants.PROP_MAIN_SLIDER},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainSliderCaptionsView, el: constants.PROP_MAIN_SLIDER_CAPTIONS}
        ],
        'control_table': [
            {view: MainTableColumnsView, el: constants.PROP_MAIN_TABLE_COLUMNS},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION},
            {view: MainTableConfigView, el: constants.PROP_MAIN_TABLE_CONFIG},
            {view: MainTableRowsView, el: constants.PROP_MAIN_TABLE_ROWS}
        ],
        'control_ranking': [{view: MainRankingView, el: constants.PROP_MAIN_RANKING},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_play_form_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{
            view: mainSelectFormOrReportView,
            el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'form', modelField: 'formName'}
        },
            {view: MainFormInstanceView, el: constants.PROP_MAIN_FORM_INSTANCE},
            {view: MainMiscFormReportView, el: constants.PROP_MAIN_MISC},
            {view: MainCustomParametersView, el: constants.PROP_MAIN_CUSTOM_PARAMETERS},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}}
        ],
        'control_play_report_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{
            view: mainSelectFormOrReportView,
            el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'report', modelField: 'reportName'}
        },
            {view: MainMiscFormReportView, el: constants.PROP_MAIN_MISC},
            {view: MainCustomParametersView, el: constants.PROP_MAIN_CUSTOM_PARAMETERS},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: AccessibilityView, el: constants.PROP_ACCESS_ID, config: {sameAsCaption: true}}
        ],
        'layout_frame': [
            //{view: MainDataSources,el:constants.PROP_MAIN_DATA_SOURCE},
            {view: mainSizeView, el: constants.PROP_MAIN_SIZE},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_FORM_INSTANCE,
                config: {viewTitle: "Instance Name", modelField: "instanceName"}
            },
            {view: styleScreenView, el: constants.PROP_STYLE_SCREEN},
            {view: styleFrameView, el: constants.PROP_STYLE_FRAME},
            {view: styleGridView, el: constants.PROP_STYLE_GRID},
            {view: stylePageTurningView, el: constants.PROP_STYLE_PAGE_TURNING},
            {view: locationView, el: constants.PROP_LOCATION},
            {view: multilanguageView, el: constants.PROP_MULTILANGUAGE},
            {view: appAccessibilityView, el: constants.PROP_APP_ACCESSIBILITY},
            {view: lockingView, el: constants.PROP_LOCKING}
        ],
        'reports_frame': [
            {view: MainDataSources, el: constants.PROP_MAIN_DATA_SOURCE},
            {view: mainSizeView, el: constants.PROP_MAIN_SIZE},
            {view: styleScreenView, el: constants.PROP_STYLE_SCREEN},
            {view: styleFrameView, el: constants.PROP_STYLE_FRAME},
            {view: styleGridView, el: constants.PROP_STYLE_GRID},
            {view: stylePageTurningView, el: constants.PROP_STYLE_PAGE_TURNING},
            {view: locationView, el: constants.PROP_LOCATION},
        ],
        'textInputColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMainTextView, el: constants.PROP_MAIN_TABLE_COLUMN_TEXT},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: MainAutocomplete, el: constants.PROP_MAIN_AUTOCOMPLETE}
        ],
        'buttonColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY}
        ],
        'checkboxColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: ColumnMainCheckboxView, el: constants.PROP_MAIN_CHECKBOX_VALUE},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'childFormColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},

            {view: ColumnMainFormSelectView, el: constants.PROP_MAIN_FORM_INSTANCE},
            {view: ColumnMainCustomParametersView, el: constants.PROP_MAIN_CUSTOM_PARAMETERS},
            {view: ColumnMainMiscView, el: constants.PROP_MAIN_MISC}
        ],
        'dateInputColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: ColumnMainDateValueView, el: constants.PROP_MAIN_DATE_VALUE},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'dropdownColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: ColumnMainDropDownView, el: constants.PROP_MAIN_TABLE_COLUMN_DROPDOWN},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'fileAttachmentColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMainFileSizeView, el: constants.PROP_MAIN_FILE_SIZE},
            {view: ColumnMainButtonLabelView, el: constants.PROP_MAIN_BUTTON_LABELS},
            {view: ColumnMainFileButtonPositionView, el: constants.PROP_MAIN_BUTTON_POSITION},
            {view: ColumnMainFileTypesView, el: constants.PROP_MAIN_FILE_TYPES},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY}
        ],
        'numericInputColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMainNumberView, el: constants.PROP_MAIN_NUMERIC},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'radioButtonColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
        ],
        'textAreaColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMainTextView, el: constants.PROP_MAIN_TABLE_COLUMN_TEXT},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY},
            {view: MainInputPurposeAutofillView, el: constants.PROP_ACCESS_AUTOFILL},
            {view: MainAutocomplete, el: constants.PROP_MAIN_AUTOCOMPLETE}

        ],
        'timeInputColumn': [{view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN},
            {view: ColumnMainTimeValueView, el: constants.PROP_MAIN_TIME_VALUE},
            {view: ColumnMandatoryView, el: constants.PROP_MAIN_MANDATORY}
        ],
        'page_instance': [{view: AccessibilityView, el: constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}
        ],
        //'layout_page' : [  {view: AccessibilityView, el: constants.PROP_ACCESS_ID} ,
        //    {view: NavAccessDescriptionView, el: constants.PROP_ACCESS_DESCRIPTION}],
        'asset': [{view: MainAssetPreviewView, el: constants.PROP_MAIN_PREVIEW}]

    };

    const attributeRoot = {
        'control_hello_world': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_bar_chart': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_value': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_filter_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_crosstab': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_gauge_chart': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_filter_selector': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_pie_chart': [
            {view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_text': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_small_text': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_medium_heading': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_large_heading': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_line_chart': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_small_heading': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_text_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
            //{view: MainMaxCharsAlignmentView, el: constants.PROP_MAIN_MAX_CHARS},
            //{view: MainFormatView, el: constants.PROP_MAIN_TEXT_FORMAT}
        ],
        'control_multiple_text_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT},
            {view: MainTextAlignmentView, el: constants.PROP_MAIN_TEXT_ALIGNMENT}
        ],
        'control_captcha': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_picture': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_group': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_checkbox_group': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_checkbox': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}],
        'control_radio_button_group': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_radio_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}],
        'control_bullet_text': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: MainTextView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_data_grid': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_data_list': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_date_calendar': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_date_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_drop_down': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_time_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_clear_filter_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_submit_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_page_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_numeric_stepper': [{view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_password_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_file_attachment': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_mask_text_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_sound': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_timer': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_movie': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_numeric_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_table': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_print_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_play_form_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_TEXT}
        ],
        'control_play_report_button': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'textInputColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'dateInputColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'buttonColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME},
            {view: ColumnMainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'checkboxColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'numericInputColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'textAreaColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'radioButtonColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}],
        'timeInputColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'dropdownColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'fileAttachmentColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'childFormColumn': [{view: ColumnMainNameView, el: constants.PROP_MAIN_NAME},
            {view: ColumnMainCaptionView, el: constants.PROP_MAIN_CAPTION}
        ],
        'control_progress_bar': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_link': [{view: MainNameView, el: constants.PROP_MAIN_NAME},
            {view: mainCaptionView, el: constants.PROP_MAIN_CAPTION}],
        'control_ranking': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'layout_frame': [{view: mainFormNameView, el: constants.PROP_MAIN_FORM_NAME}],
        'reports_frame': [{view: mainFormNameView, el: constants.PROP_MAIN_FORM_NAME}],
        'page_instance': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        //'layout_page' : [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_vertical_slider': [
            {view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_horizontal_slider': [
            {view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_websignature': [
            {view: MainNameView, el: constants.PROP_MAIN_NAME}
        ],
        'control_vertical_separator': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_horizontal_separator': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_list': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'control_image_input': [{view: MainNameView, el: constants.PROP_MAIN_NAME}],
        'asset': [{view: MainAssetNameView, el: constants.PROP_MAIN_NAME}],
        'workflow_stage': [
            {view: MainStageWorkflowView, el: constants.PROP_MAIN_NAME}
        ],
        'workflow_comment': [],
        'behavior_instance': [
            {view: BehaviorInstanceView, el: constants.PROP_MAIN_NAME}
        ],
        'workflow_page': [
            {view: mainFormStatusView, el: constants.PROP_MAIN_FORM_NAME}
        ],
        'connection_arrow': [
            {view: mainCaptionView, el: constants.PROP_MAIN_NAME}
        ]
    };

    const styleRoot = {
        'control_crosstab': [
            {view: StyleTableHeaderTextView, el: constants.PROP_STYLE_HEADER_TEXT},
            {view: StyleTableHeaderBackgroundView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleTableRowTextView, el: constants.PROP_STYLE_ROWS_TEXT},
            {view: StyleTableRowsBackgroundView, el: constants.PROP_STYLE_ROWS_BACKGROUND}
        ],
        'control_data_grid': [
            {view: StyleTableHeaderTextView, el: constants.PROP_STYLE_HEADER_TEXT},
            {view: StyleTableHeaderBackgroundView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleTableRowTextView, el: constants.PROP_STYLE_ROWS_TEXT},
            {view: StyleTableRowsBackgroundView, el: constants.PROP_STYLE_ROWS_BACKGROUND}
        ],
        'control_data_list': [
            {view: StyleTableHeaderTextView, el: constants.PROP_STYLE_HEADER_TEXT},
            {view: StyleTableHeaderBackgroundView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleTableRowTextView, el: constants.PROP_STYLE_ROWS_TEXT},
            {view: StyleTableRowsBackgroundView, el: constants.PROP_STYLE_ROWS_BACKGROUND}
        ],
        'control_bar_chart': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleGraphColorView, el: constants.PROP_STYLE_GRAPH_COLOR}
        ],
        'control_gauge_chart': [
            {view: StyleGaugeNeedleView, el: constants.PROP_STYLE_GAUGE_NEEDLE},
            {view: StyleGaugeBackgroundView, el: constants.PROP_STYLE_GAUGE_BACKGROUND}
        ],
        'control_filter_selector': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_line_chart': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleGraphColorView, el: constants.PROP_STYLE_GRAPH_COLOR}
        ],
        'control_clear_filter_button': [
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleBackgroundClearFilterView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_pie_chart': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylePieSliceView, el: constants.PROP_STYLE_GRAPH_COLOR}
        ],
        'control_text': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_small_text': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_value': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_filter_input': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_medium_heading': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_small_heading': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_large_heading': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_text_input': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_captcha': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_drop_down': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},

            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_group': [
            //{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleHeaderFontView, el: constants.PROP_STYLE_TEXT},
            //{view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            // {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleHeaderBGColorView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_bullet_text': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_date_input': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},

            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_date_calendar': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'control_time_input': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_page_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_submit_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_multiple_text_input': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_file_attachment': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleButtonFontView, el: constants.PROP_STYLE_BUTTON_FONT},
            {view: StyleSignatureButtonBackgroundView, el: constants.PROP_STYLE_BUTTON_BACKGROUND},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_numeric_stepper': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},

            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_print_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_vertical_separator': [{view: StyleLineView, el: constants.PROP_STYLE_LINE},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'control_horizontal_separator': [{view: StyleLineView, el: constants.PROP_STYLE_LINE},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'control_play_form_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_play_report_button': [{view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_link': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_progress_bar': [{view: StyleLabelView, el: constants.PROP_STYLE_LABEL},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBarView, el: constants.PROP_STYLE_BAR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION}
        ],
        'textInputColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'dateInputColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: ColumnStyleBorderSimpleView, el: constants.PROP_STYLE_BORDER}
        ],
        'buttonColumn': [{view: ColumnStyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: ColumnStyleButtonBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: ColumnStyleBorderSimpleView, el: constants.PROP_STYLE_BORDER}
        ],
        'checkboxColumn': [{view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'numericInputColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'textAreaColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'radioButtonColumn': [{view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'timeInputColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: ColumnStyleBorderView, el: constants.PROP_STYLE_BORDER}
        ],
        'dropdownColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND}
        ],
        'fileAttachmentColumn': [{view: ColumnStyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: ColumnStyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: ColumnStyleButtonView, el: constants.PROP_STYLE_CAPTION}
        ],
        'childFormColumn': [{view: ColumnStyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: ColumnStyleButtonBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: ColumnStyleBorderSimpleView, el: constants.PROP_STYLE_BORDER}
        ],
        'layout_frame': [
            {view: advancedCSSView, el: constants.PROP_THEME_ADVANCED_CSS},
            {view: exportImportTheme, el: constants.PROP_THEME_EXPORT_IMPORT},
            {view: themePagesView, el: constants.PROP_THEME_PAGE},
            {view: themeTextsView, el: constants.PROP_THEME_TEXTS},
            {view: themeInputsView, el: constants.PROP_THEME_INPUTS},
            {view: themeButtonsView, el: constants.PROP_THEME_BUTTONS},
            {view: themeCheckboxesView, el: constants.PROP_THEME_CHECKBOXES},
            {view: themeGroupsView, el: constants.PROP_THEME_GROUPS},
            {view: themeTablesView, el: constants.PROP_THEME_TABLES},
            {view: themeMiscView, el: constants.PROP_THEME_MISC}
        ],
        'reports_frame': [
            {view: advancedCSSView, el: constants.PROP_THEME_ADVANCED_CSS},
            {view: exportImportTheme, el: constants.PROP_THEME_EXPORT_IMPORT},
            {view: themePagesView, el: constants.PROP_THEME_PAGE},
            {view: themeTextsView, el: constants.PROP_THEME_TEXTS},
            {view: themeInputsView, el: constants.PROP_THEME_INPUTS},
            {view: themeButtonsView, el: constants.PROP_THEME_BUTTONS},
            {view: themeCheckboxesView, el: constants.PROP_THEME_CHECKBOXES},
            {view: themeGroupsView, el: constants.PROP_THEME_GROUPS},
            {view: themeTablesView, el: constants.PROP_THEME_TABLES},
            {view: themeMiscView, el: constants.PROP_THEME_MISC}
        ],
        'control_vertical_slider': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleSliderScaleView, el: constants.PROP_STYLE_SLIDER_SCALE}

        ],
        'control_horizontal_slider': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleSliderScaleView, el: constants.PROP_STYLE_SLIDER_SCALE}
        ],
        'control_websignature': [
            //{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleButtonFontView, el: constants.PROP_STYLE_BUTTON_FONT},
            //{view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            //{view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleSignatureButtonBackgroundView, el: constants.PROP_STYLE_BUTTON_BACKGROUND},
            {view: StyleSignatureColorAndThicknessView, el: constants.PROP_STYLE_COLOR_THICKNESS},
            {view: StyleImageBackgroundView, el: constants.PROP_STYLE_IMAGE_BACKGROUND},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],

        'control_numeric_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},

            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_checkbox': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_checkbox_group': [
            {view: StyleHeaderFontView, el: constants.PROP_STYLE_TEXT},
            //{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            //{view: StyleFontView, el: constants.PROP_STYLE_FONT},
            //{view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            //{view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleHeaderBGColorView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_radio_button_group': [
            {view: StyleHeaderFontView, el: constants.PROP_STYLE_TEXT},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleHeaderBGColorView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_radio_button': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_list': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},

            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_ranking': [{view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_mask_text_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},

            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_password_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},

            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'control_image_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleButtonFontView, el: constants.PROP_STYLE_BUTTON_FONT},
            {view: StyleSignatureButtonBackgroundView, el: constants.PROP_STYLE_BUTTON_BACKGROUND},
            {view: StyleImageBackgroundView, el: constants.PROP_STYLE_IMAGE_BACKGROUND},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}

        ],
        'control_table': [
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleTableHeaderTextView, el: constants.PROP_STYLE_HEADER_TEXT},
            {view: StyleTableHeaderBackgroundView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleTableRowsBackgroundView, el: constants.PROP_STYLE_ROWS_BACKGROUND},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}
        ],
        'page_instance': [
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {
                view: StyleBackgroundPictureView,
                el: constants.PROP_ACCESS_BACKGROUND_PICTURE,
                config: {viewTitle: "Background Picture"}
            },
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'layout_page': [{view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'report_page': [{view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}]
    };


    const mobileStyleRoot = {

        'layout_frame': [
            {view: themeTextsView, el: constants.PROP_THEME_TEXTS},
            {view: themeInputsView, el: constants.PROP_THEME_INPUTS},
            {view: themeButtonsView, el: constants.PROP_THEME_BUTTONS},
            {view: themeCheckboxesView, el: constants.PROP_THEME_CHECKBOXES},
            {view: themeGroupsView, el: constants.PROP_THEME_GROUPS},
            {view: themeTablesView, el: constants.PROP_THEME_TABLES},
            {view: themeMiscView, el: constants.PROP_THEME_MISC}
        ],
       //Inputs
        'control_text_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_multiple_text_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_numeric_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},

            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_date_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER}
        ],
        'control_time_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER}
        ],
        'control_checkbox': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR}
        ],
        'control_radio_button': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR}
        ],
        'control_drop_down': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER}
        ],
        'control_mask_text_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR}
        ],
        'control_numeric_stepper': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_password_input': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_horizontal_slider': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleSliderScaleView, el: constants.PROP_STYLE_SLIDER_SCALE}
        ],
        'control_websignature': [
            {view: StyleButtonFontView, el: constants.PROP_STYLE_BUTTON_FONT},
            {view: StyleSignatureButtonBackgroundView, el: constants.PROP_STYLE_BUTTON_BACKGROUND},
            {view: StyleSignatureColorAndThicknessView, el: constants.PROP_STYLE_COLOR_THICKNESS},
            {view: StyleImageBackgroundView, el: constants.PROP_STYLE_IMAGE_BACKGROUND}
        ],

        //Buttons
        'control_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_page_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_submit_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_print_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_play_form_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],
        'control_play_report_button': [
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER},
            {view: StyleCaptionView, el: constants.PROP_STYLE_CAPTION},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleColorsView, el: constants.PROP_STYLE_COLORS},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundGradientColor, el: constants.PROP_STYLE_BACKGROUND_GRADIENT_COLOR},
            {view: StyleAdvancedBackgroundColorView, el: constants.PROP_STYLE_ADVANCED_BACKGROUND_COLOR}
        ],

        //Layouts
        'control_text': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_small_text': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_medium_heading': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_small_heading': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_large_heading': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_bullet_text': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_link': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleMouseOverView, el: constants.PROP_STYLE_MOUSE_OVER}
        ],
        'control_horizontal_separator': [
            {view: StyleLineView, el: constants.PROP_STYLE_LINE}
        ],

        //Containers
        'control_list': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR}
        ],
        'control_progress_bar': [
            {view: StyleLabelView, el: constants.PROP_STYLE_LABEL},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleBarView, el: constants.PROP_STYLE_BAR},
            {view: StyleBorderView, el: constants.PROP_STYLE_BORDER}
        ],
        'control_captcha': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR}
        ],
        'control_file_attachment': [
            {view: StyleTextView, el: constants.PROP_STYLE_TEXT},
            {view: StyleFontView, el: constants.PROP_STYLE_FONT},
            {view: StyleTextStyleView, el: constants.PROP_STYLE_TEXT_STYLE},
            {view: StyleTextColorView, el: constants.PROP_STYLE_TEXT_COLOR},
            {view: StyleButtonFontView, el: constants.PROP_STYLE_BUTTON_FONT},
            {view: StyleSignatureButtonBackgroundView, el: constants.PROP_STYLE_BUTTON_BACKGROUND}

        ],

        'page_instance': [
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {
                view: StyleBackgroundPictureView,
                el: constants.PROP_ACCESS_BACKGROUND_PICTURE,
                config: {viewTitle: "Background Picture"}
            },
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'layout_page': [{view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'report_page': [{view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StylesThemeResetView, el: constants.PROP_STYLE_THEMERESET}],
        'control_section': [
            {view: StyleHeaderFontView, el: constants.PROP_STYLE_TEXT},
            {view: StyleHeaderBGColorView, el: constants.PROP_STYLE_HEADER_BG_COLOR},
            {view: StyleBackgroundView, el: constants.PROP_STYLE_BACKGROUND},
            {view: StyleBackgroundColorView, el: constants.PROP_STYLE_BACKGROUND_COLOR},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: StyleAdvancedBorderView, el: constants.PROP_STYLE_ADVANCED_BORDER}
        ]
    };

    const themeRoot = {
        'layout_frame': [{view: themePagesView, el: constants.PROP_THEME_PAGE},
            {view: themeTextsView, el: constants.PROP_THEME_TEXTS},
            {view: themeInputsView, el: constants.PROP_THEME_INPUTS},
            {view: themeButtonsView, el: constants.PROP_THEME_BUTTONS},
            {view: themeCheckboxesView, el: constants.PROP_THEME_CHECKBOXES},
            {view: themeGroupsView, el: constants.PROP_THEME_GROUPS},
            {view: themeTablesView, el: constants.PROP_THEME_TABLES},
            {view: themeMiscView, el: constants.PROP_THEME_MISC}
        ],
        'reports_frame': [{view: themePagesView, el: constants.PROP_THEME_PAGE},
            {view: themeTextsView, el: constants.PROP_THEME_TEXTS},
            {view: themeInputsView, el: constants.PROP_THEME_INPUTS},
            {view: themeButtonsView, el: constants.PROP_THEME_BUTTONS},
            {view: themeCheckboxesView, el: constants.PROP_THEME_CHECKBOXES},
            {view: themeGroupsView, el: constants.PROP_THEME_GROUPS},
            {view: themeTablesView, el: constants.PROP_THEME_TABLES},
            {view: themeMiscView, el: constants.PROP_THEME_MISC}
        ]
    };

    const settingsMobileRoot = {
        'layout_frame': [
            {view: MobileMainFormView, el: constants.PROP_MAIN_FORM_INSTANCE},
            {view: styleScreenView, el: constants.PROP_STYLE_SCREEN}
        ],        
        'page_instance': [ ],       
        //Inputs
        'control_text_input': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}          
        ],
        'control_multiple_text_input':[
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_numeric_input': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_date_input': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_time_input': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],      
        'control_checkbox': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_radio_button': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_drop_down':[
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_mask_text_input': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_numeric_stepper': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_password_input': [
            {view: mainPasswordView, el: constants.PROP_MAIN_PASSWORD},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}          
        ],
        'control_websignature': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_horizontal_slider': [
            {view: MainSliderView, el: constants.PROP_MAIN_SLIDER},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        'control_ranking': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}      
        ],
        //Buttons
        'control_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        'control_submit_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        'control_page_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        'control_print_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        'control_play_form_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        'control_play_report_button': [
            {view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}  
        ],
        //Layout
        'control_text': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_small_text': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_large_heading': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_medium_heading': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_small_heading': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_bullet_text': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_link': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_horizontal_separator': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        //Containers
        'control_list': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_progress_bar': [
            {view: MainLabelView, el: constants.PROP_MAIN_LABEL},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_captcha': [
            {view: mainLengthView, el: constants.PROP_MAIN_LENGTH},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_file_attachment': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_picture': [
            {view: MainPictureView, el: constants.PROP_MAIN_PICTURE},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        //Table
        'control_table': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        //Groups
        'control_checkbox_group': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_radio_button_group': [
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ],
        'control_section': [{view: mainHeaderView, el: constants.PROP_MAIN_HEADER},
            {view: MobileMainMarginsView, el: mobileConstants.PROP_MAIN_MOBILE_MARGINS}
        ]
    };

// The Specific Configurations for Tablet and Phone allow these devices to be configured with different property views (Shared or Stand Alone).
    const settingsTabletRoot = {
        'layout_frame': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'reports_frame': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'page_instance': [
            {
                view: StyleBackgroundPictureView,
                el: constants.PROP_SETTING_BACKGROUND_PICTURE,
                config: {showTitle: true}
            },
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_text': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_small_text': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_medium_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_large_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_small_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_picture': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainPictureView, el: constants.PROP_MAIN_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE, config: {disabled: true}},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_crosstab': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_clear_filter_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_value': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_filter_input': [           
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_submit_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_page_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_group': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_bullet_text': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_vertical_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_horizontal_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_movie': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_sound': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_link': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_line_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_progress_bar': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_print_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_timer': [{view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_captcha': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_multiple_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_numeric_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_date_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_time_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_date_calendar': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_checkbox': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_checkbox_group': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_radio_button_group': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_radio_button': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_list': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_drop_down': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_numeric_stepper': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_mask_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_password_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_file_attachment': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_image_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_websignature': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_vertical_slider': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_horizontal_slider': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_ranking': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_play_form_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_play_report_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_pie_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_table': [
            {view: MainTableColumnsView, el: constants.PROP_MAIN_TABLE_COLUMNS},
            {view: MainTableConfigView, el: constants.PROP_MAIN_TABLE_CONFIG},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainTableRowsView, el: constants.PROP_MAIN_TABLE_ROWS},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'textInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'buttonColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'checkboxColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'childFormColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'dateInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'dropdownColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'fileAttachmentColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'numericInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'radioButtonColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'textAreaColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'timeInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_data_grid': [{view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_bar_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_gauge_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_data_list': [
            {view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ]
    }

    const settingsPhoneRoot = {
        'layout_frame': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'reports_frame': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'page_instance': [
            {
                view: StyleBackgroundPictureView,
                el: constants.PROP_SETTING_BACKGROUND_PICTURE,
                config: {showTitle: true}
            },
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_text': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_small_text': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_medium_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_large_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_small_heading': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_picture': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainPictureView, el: constants.PROP_MAIN_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE, config: {disabled: true}},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_crosstab': [{view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_clear_filter_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_value': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_filter_input': [            
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_submit_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_page_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_group': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: StyleBackgroundPictureView, el: constants.PROP_STYLE_BACKGROUND_PICTURE},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_bullet_text': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_vertical_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_horizontal_separator': [{view: NavPositionView, el: constants.PROP_NAV_POSITION}],
        'control_movie': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_sound': [
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_link': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_line_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_progress_bar': [
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_print_button': [{
            view: mainButtonTypeView,
            el: constants.PROP_MAIN_BUTTON_TYPE,
            config: {disabled: true}
        },
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_timer': [{view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_captcha': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_multiple_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_numeric_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_date_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_time_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_date_calendar': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_checkbox': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_checkbox_group': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_radio_button_group': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_radio_button': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_list': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_drop_down': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_numeric_stepper': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_mask_text_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_password_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_file_attachment': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_image_input': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_websignature': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_vertical_slider': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_horizontal_slider': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_ranking': [{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_play_form_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_play_report_button': [{view: mainButtonTypeView, el: constants.PROP_MAIN_BUTTON_TYPE},{view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'control_pie_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_table': [
            {view: MainTableColumnsView, el: constants.PROP_MAIN_TABLE_COLUMNS},
            {view: MainTableConfigView, el: constants.PROP_MAIN_TABLE_CONFIG},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: NavTabbingView, el: constants.PROP_NAV_TABBING, config: {hideTooltip: true}},
            {view: MainTableRowsView, el: constants.PROP_MAIN_TABLE_ROWS},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}],
        'textInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'buttonColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'checkboxColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'childFormColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'dateInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'dropdownColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'fileAttachmentColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'numericInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'radioButtonColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'textAreaColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'timeInputColumn': [
            {view: ColumnMainColumnView, el: constants.PROP_MAIN_TABLE_COLUMN, config: {mobileMode: true}},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_data_grid': [{view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_bar_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_gauge_chart': [
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ],
        'control_data_list': [
            {view: MainDataView, el: constants.PROP_MAIN_DROPDOWN},
            {view: NavPositionView, el: constants.PROP_NAV_POSITION},
            {view: MainSharedSettingsLinkView, el: constants.PROP_SHARED_SETTINGS_LINK}
        ]
    }

// Currently the Tablet and Phone have the same Shared Settings, but if this changes in the future, this will allow for easy configuration.
    const sharedSettingsPhoneRoot = {
        'page_instance': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }],
        'control_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_small_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_medium_heading': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_large_heading': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_small_heading': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID
        },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_picture': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID
        },
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_button': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
            config: {sameAsCaption: true}
        },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_crosstab': [
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {
                view: MainCrosstabColumnsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS
            },
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_clear_filter_button': [{
            view: mainButtonTypeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_TYPE
        },
            {
                view: MainDataSourceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
            }
        ],
        'control_value': [{
            view: MainDataSourceView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
        },
            {view: MainValueView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_VALUE},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_filter_input': [
            {view: MainFilterTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILTER_TYPE},
            {
                view: MainDataSourceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
            },
            {view: MainFieldView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FIELD},
            {
                view: MainFilterOverrideView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILTER_OVERRIDE
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_submit_button': [
            {view: MainShowSuccessView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SHOW_SUCCESS},
            {
                view: MainSubmitAsChildView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SUBMIT_AS_CHILD
            },
            {
                view: MainAfterSubmissionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_AFTER_SUBMISSION
            },
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: MainUrlView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_URL}
        ],
        'control_page_button': [
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: MainPageView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE}
        ],
        'control_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: NavTabbingView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_bullet_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_movie': [
            {view: MainMovieView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MEDIA_SETTINGS},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_sound': [
            {view: MainSoundView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MEDIA_SETTINGS},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_link': [{view: MainUrlView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_URL},
            {view: MainTargetView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TARGET},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT}
        ],
        'control_line_chart': [
            {view: MainLineChartTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: MainChartAxesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {
                view: MainChartFilterView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER_COLUMN2
            },
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_progress_bar': [
            {
                view: MainProgressView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PROGRESS,
                config: {hideTitle: true}
            },
            {view: MainLabelView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LABEL},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_print_button': [
            {view: mainButtonTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_TYPE},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: PagesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: SectionsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_SECTIONS},
            {view: AppendixSizeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_APPENDIX_SIZE_VIEW}
        ],
        'control_timer': [{
            view: mainTimerView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIMER,
            config: {showTitle: true}
        },
            {view: mainAutoStartView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_AUTO_START}
        ],
        'control_captcha': [
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: mainLengthView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LENGTH,
                config: {showTitle: true}
            }
        ],
        'control_text_input': [
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: MainFormatView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TEXT_FORMAT},
            {
                view: MainMaxCharsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MAX_CHARS,
                config: {showTitle: true}
            }
        ],
        'control_multiple_text_input': [
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: StyleScrollbarsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_STYLE_SCROLLBARS},
            {
                view: MainMaxCharsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MAX_CHARS,
                config: {showTitle: true}
            }
        ],
        'control_numeric_input': [
            {
                view: mainNumericView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMBER,
                config: {showTitle: true}
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP_COLUMN2},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_date_input': [{
            view: mainDateValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATE_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_time_input': [{
            view: mainTimeValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIME_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_date_calendar': [{
            view: mainCalendarValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CALENDAR_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_checkbox': [{
            view: MainCheckboxView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHECKBOX_VALUE
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_checkbox_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_radio_button_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_radio_button': [{
            view: MainRadioButtonView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_RADIO_BUTTON_VALUE
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_list': [
            {view: mainListItemView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LIST_ITEM},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_drop_down': [{
            view: mainDropDownView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_numeric_stepper': [{
            view: MainNumberView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMBER,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_mask_text_input': [{
            view: mainMaskView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MASK,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_password_input': [{
            view: mainPasswordView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PASSWORD,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_file_attachment': [{
            view: mainFileSizeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE,
            config: {showTitle: true}
        },
            {view: mainFileTypesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_TYPES},
            {
                view: mainButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: mainButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_image_input': [{
            view: mainFileSizeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE
        },
            {
                view: MainImageButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: MainImageButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_websignature': [
            {
                view: mainButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS,
                config: {showTitle: true}
            },
            {
                view: mainButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_vertical_slider': [
            {view: MainSliderView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: MainSliderCaptionsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER_CAPTIONS
            }
        ],
        'control_horizontal_slider': [
            {view: MainSliderView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: MainSliderCaptionsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER_CAPTIONS
            }
        ],
        'control_ranking': [{
            view: MainRankingView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_RANKING
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_play_form_button': [{
            view: mainSelectFormOrReportView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'form', modelField: 'formName'}
        },
            {
                view: MainFormInstanceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FORM_INSTANCE
            },
            {view: MainMiscFormReportView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC},
            {
                view: MainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_play_report_button': [{
            view: mainSelectFormOrReportView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'form', modelField: 'reportName'}
        },
            {view: MainMiscFormReportView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC},
            {
                view: MainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_pie_chart': [
            {
                view: MainPieChartLabelView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_REPORT_SETTINGS
            },
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_table': [
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: MainTableRowsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_ROWS}
        ],
        'textInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTextView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_TEXT
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'buttonColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'checkboxColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: ColumnMainCheckboxView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHECKBOX_VALUE
            }
        ],
        'childFormColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},

            {
                view: ColumnMainFormSelectView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FORM_INSTANCE
            },
            {
                view: ColumnMainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: ColumnMainMiscView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC}
        ],
        'dateInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: ColumnMainDateValueView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATE_VALUE}
        ],
        'dropdownColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: ColumnMainDropDownView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_DROPDOWN
            }
        ],
        'fileAttachmentColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMainFileSizeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE},
            {
                view: ColumnMainButtonLabelView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: ColumnMainFileButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {
                view: ColumnMainFileTypesView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_TYPES
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'numericInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMainNumberView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMERIC},
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'radioButtonColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'textAreaColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTextView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_TEXT
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'timeInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTimeValueView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIME_VALUE
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_data_grid': [
            {view: MainDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_bar_chart': [
            {view: MainChartAxesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_gauge_chart': [
            {view: MainChartScaleView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {view: MainChartMiscAccesibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_data_list': [{view: MainDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION}
        ]
    };

    const sharedSettingsTabletRoot = {
        'page_instance': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }],
        'control_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_small_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_medium_heading': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_large_heading': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_small_heading': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID
        },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_picture': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID
        },
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_button': [{
            view: AccessibilityView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
            config: {sameAsCaption: true}
        },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_crosstab': [
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {
                view: MainCrosstabColumnsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS
            },
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_clear_filter_button': [{
            view: mainButtonTypeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_TYPE
        },
            {
                view: MainDataSourceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
            }
        ],
        'control_value': [{
            view: MainDataSourceView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
        },
            {view: MainValueView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_VALUE},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_filter_input': [
            {view: MainFilterTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILTER_TYPE},
            {
                view: MainDataSourceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATA_SOURCE_SINGLE
            },
            {view: MainFieldView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FIELD},
            {
                view: MainFilterOverrideView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILTER_OVERRIDE
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_submit_button': [
            {view: MainShowSuccessView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SHOW_SUCCESS},
            {
                view: MainSubmitAsChildView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SUBMIT_AS_CHILD
            },
            {
                view: MainAfterSubmissionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_AFTER_SUBMISSION
            },
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: MainUrlView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_URL}
        ],
        'control_page_button': [
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: MainPageView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE}
        ],
        'control_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: NavTabbingView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_NAV_TABBING},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_bullet_text': [
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}
        ],
        'control_movie': [
            {view: MainMovieView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MEDIA_SETTINGS},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_sound': [
            {view: MainSoundView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MEDIA_SETTINGS},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP}],
        'control_link': [{view: MainUrlView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_URL},
            {view: MainTargetView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TARGET},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessSilent, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_SILENT}
        ],
        'control_line_chart': [
            {view: MainLineChartTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: MainChartAxesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {
                view: MainChartFilterView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER_COLUMN2
            },
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_progress_bar': [
            {
                view: MainProgressView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PROGRESS,
                config: {hideTitle: true}
            },
            {view: MainLabelView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LABEL},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_print_button': [
            {view: mainButtonTypeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_TYPE},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: PagesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: SectionsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_SECTIONS},
            {view: AppendixSizeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_APPENDIX_SIZE_VIEW}
        ],
        'control_timer': [{
            view: mainTimerView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIMER,
            config: {showTitle: true}
        },
            {view: mainAutoStartView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_AUTO_START}
        ],
        'control_captcha': [
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: mainLengthView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LENGTH,
                config: {showTitle: true}
            }
        ],
        'control_text_input': [
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: MainFormatView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TEXT_FORMAT},
            {
                view: MainMaxCharsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MAX_CHARS,
                config: {showTitle: true}
            }
        ],
        'control_multiple_text_input': [
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: StyleScrollbarsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_STYLE_SCROLLBARS},
            {
                view: MainMaxCharsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MAX_CHARS,
                config: {showTitle: true}
            }
        ],
        'control_numeric_input': [
            {
                view: mainNumericView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMBER,
                config: {showTitle: true}
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP_COLUMN2},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_date_input': [{
            view: mainDateValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATE_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_time_input': [{
            view: mainTimeValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIME_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_date_calendar': [{
            view: mainCalendarValueView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CALENDAR_VALUE,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_checkbox': [{
            view: MainCheckboxView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHECKBOX_VALUE
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            },
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_checkbox_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_radio_button_group': [{
            view: mainHeaderView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_HEADER
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_radio_button': [{
            view: MainRadioButtonView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_RADIO_BUTTON_VALUE
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_list': [
            {view: mainListItemView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_LIST_ITEM},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_drop_down': [{
            view: mainDropDownView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_numeric_stepper': [{
            view: MainNumberView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMBER,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_mask_text_input': [{
            view: mainMaskView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MASK,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_password_input': [{
            view: mainPasswordView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PASSWORD,
            config: {showTitle: true}
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: MainEncryptView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_ENCRYPT},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_file_attachment': [{
            view: mainFileSizeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE,
            config: {showTitle: true}
        },
            {view: mainFileTypesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_TYPES},
            {
                view: mainButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: mainButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_image_input': [{
            view: mainFileSizeView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE
        },
            {
                view: MainImageButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: MainImageButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_websignature': [
            {
                view: mainButtonLabelsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS,
                config: {showTitle: true}
            },
            {
                view: mainButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_vertical_slider': [
            {view: MainSliderView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: MainSliderCaptionsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER_CAPTIONS
            }
        ],
        'control_horizontal_slider': [
            {view: MainSliderView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER},
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {
                view: MainSliderCaptionsView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SLIDER_CAPTIONS
            }
        ],
        'control_ranking': [{
            view: MainRankingView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_RANKING
        },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_play_form_button': [{
            view: mainSelectFormOrReportView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'form', modelField: 'formName'}
        },
            {
                view: MainFormInstanceView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FORM_INSTANCE
            },
            {view: MainMiscFormReportView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC},
            {
                view: MainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_play_report_button': [{
            view: mainSelectFormOrReportView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
            config: {mode: 'report', modelField: 'reportName'}
        },
            {view: MainMiscFormReportView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC},
            {
                view: MainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {
                view: AccessibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID,
                config: {sameAsCaption: true}
            }
        ],
        'control_pie_chart': [
            {
                view: MainPieChartLabelView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_REPORT_SETTINGS
            },
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID_COLUMN2},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_table': [
            {view: NavTooltipView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_TOOLTIP},
            {view: MainMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            },
            {view: MainTableRowsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_ROWS}
        ],
        'textInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTextView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_TEXT
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'buttonColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'checkboxColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: ColumnMainCheckboxView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHECKBOX_VALUE
            }
        ],
        'childFormColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},

            {
                view: ColumnMainFormSelectView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FORM_INSTANCE
            },
            {
                view: ColumnMainCustomParametersView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CUSTOM_PARAMETERS
            },
            {view: ColumnMainMiscView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MISC}
        ],
        'dateInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {view: ColumnMainDateValueView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DATE_VALUE}
        ],
        'dropdownColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY},
            {
                view: ColumnMainDropDownView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_DROPDOWN
            }
        ],
        'fileAttachmentColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMainFileSizeView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_SIZE},
            {
                view: ColumnMainButtonLabelView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_LABELS
            },
            {
                view: ColumnMainFileButtonPositionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_BUTTON_POSITION
            },
            {
                view: ColumnMainFileTypesView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_FILE_TYPES
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'numericInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMainNumberView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_NUMERIC},
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'radioButtonColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'textAreaColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTextView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN_TEXT
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'timeInputColumn': [{
            view: ColumnMainColumnView,
            el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TABLE_COLUMN,
            config: {mobileSharedMode: true}
        },
            {
                view: ColumnMainTimeValueView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_TIME_VALUE
            },
            {view: ColumnMandatoryView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_MANDATORY}
        ],
        'control_data_grid': [
            {view: MainDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_bar_chart': [
            {view: MainChartAxesView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldsView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartSortView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_SORT},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {
                view: MainChartMiscAccesibilityView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY
            },
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {
                view: NavAccessDescriptionView,
                el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION
            }
        ],
        'control_gauge_chart': [
            {view: MainChartScaleView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_PAGE},
            {view: MainChartDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_DATA},
            {view: MainChartFieldView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FIELDS},
            {view: MainChartFilterView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_FILTER},
            {view: MainChartMiscAccesibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_CHART_MISC_ACCESIBILITY},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION}
        ],
        'control_data_list': [{view: MainDataView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_MAIN_DROPDOWN},
            {view: AccessibilityView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_ID},
            {view: NavAccessDescriptionView, el: constants.DIALOG_SHARED_SETTINGS + ' ' + constants.PROP_ACCESS_DESCRIPTION}
        ]
    }

    const behaviorSettingsRoot = {
        'command_exit': [
            {view: MainExitView, el: constants.PROP_MAIN_EXIT}
        ],
        'command_cancel_notification': [
            {view: MainCancellationView, el: constants.PROP_MAIN_CANCELLATION}
        ],
        'command_connect': [
            {view: MainConnectView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS},
            {view: MainSendView, el: constants.PROP_MAIN_SEND},
            {view: MainReturnView, el: constants.PROP_MAIN_RETURN}
        ],
        'command_connect_search': [
            {view: MainConnectView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS, config: {mode: 'search'}},
            {view: MainSendView, el: constants.PROP_MAIN_SEND},
            {view: MainReturnView, el: constants.PROP_MAIN_RETURN}
        ],
        'command_simple_branch': [
            {view: MainConditionView, el: constants.PROP_MAIN_CONDITION}
        ],
        'command_comment': [
            {view: MainCommentView, el: constants.PROP_MAIN_COMMENT}
        ],
        'command_call_javascript': [
            {view: MainFunctionView, el: constants.PROP_MAIN_FUNCTION},
            {view: MainCustomParametersView, el: constants.PROP_MAIN_PARAMETERS},
            {view: MainReturnValueTargetView, el: constants.PROP_MAIN_RETURN_VALUE_TARGET}
        ],
        'command_close': [
            {view: MainCloseView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS_BOTTOM,
                config: {viewTitle: "Redirect URL", modelField: "default"}
            }
        ],
        'command_show_url': [
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS,
                config: {viewTitle: "Show URL Settings", modelField: "default"}
            },
            {view: MainBrowserWindowView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS_BOTTOM}
        ],
        'command_show_page': [
            {view: MainSelectPage, el: constants.PROP_MAIN_SELECT_PAGE}
        ],
        'command_show': [
            {view: MainSelectObject, el: constants.PROP_MAIN_SELECT_OBJECT}
        ],
        'command_show_form': [
            {
                view: mainSelectFormOrReportView,
                el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
                config: {mode: 'form', modelField: 'formName'}
            },
            {view: MainShowFormView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS},
            {view: MainInstanceNameView, el: constants.PROP_MAIN_INSTANCE_NAME_VIEW},
            {view: MainCustomParametersView, el: constants.PROP_MAIN_CUSTOM_PARAMETERS}
        ],
        'command_print': [
            {view: MainPrintView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}],
        'command_copy_field_values': [
            {view: MainCopyFieldsView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}],
        'command_set_selection_items': [
            {view: MainSetFieldView, el: constants.PROP_MAIN_BEHAVIOR_SET_FIELD_SETTINGS, config: {mode: 'lists'}},
            {view: MainSetSelectionItemsView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}],
        'command_check_obligatory': [
            {view: MainCheckMandatorySettings, el: constants.PROP_MAIN_CONDITION}
        ],
        'command_get_field_from_other': [
            //{view: MainGetFieldFromView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS},
            //{view: SelectValuePropertyView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS_BOTTOM, config:{viewTitle: "Form Instance ID", modelField:"default"}}

            {
                view: mainSelectFormOrReportView,
                el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
                config: {mode: 'form', modelField: 'formName'}
            },
            {view: MainGetFieldFromView, el: constants.PROP_MAIN_SELECT_TARGET_FIELD},
            {
                view: mainSelectFormFieldView,
                el: constants.PROP_MAIN_SELECT_FORM_FIELD,
                config: {modelField: "formName"}
            },
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS_BOTTOM,
                config: {viewTitle: "App Instance ID", modelField: "instanceId"}
            }
        ],
        'command_notify': [
            {view: MainNotifyView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}
        ],
        'command_set_next_stage': [
            {view: MainNextStageView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}
        ],
        'command_show_report': [
            {
                view: mainSelectFormOrReportView,
                el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
                config: {mode: 'report', modelField: 'reportName'}
            },
            {view: mainReportMiscView, el: constants.PROP_MAIN_SELECT_FORM_FIELD},
            {view: MainCustomParametersView, el: constants.PROP_MAIN_CUSTOM_PARAMETERS}
        ],
        'command_show_message': [
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS,
                config: {viewTitle: "Show Message Settings", modelField: "default"}
            },
            {view: MainTitleView, el: constants.PROP_MAIN_BEHAVIOR_TITLE},
            {view: MessageTypeView, el: constants.PROP_MAIN_BEHAVIOR_TYPE}
        ],
        'command_set_state': [
            {view: MainObjectStatesView, el: constants.PROP_MAIN_OBJECT_STATES_VIEW}],
        'command_start_stop': [
            {view: MainStartStopView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}
        ],
        'command_set_field_value': [
            {view: MainSetFieldView, el: constants.PROP_MAIN_BEHAVIOR_SET_FIELD_SETTINGS},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS,
                config: {viewTitle: "Value", modelField: "default", fieldName: "default"}
            }
        ],
        'command_submit_data': [
            {view: MainConfirmationView, el: constants.PROP_MAIN_CONFIRMATION_SETTINGS},
            {view: MainAfterSubmissionView, el: constants.PROP_MAIN_AFTER_SUBMISSION},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_REDIRECT_URL,
                config: {viewTitle: "Redirect URL", modelField: "default"}
            }
        ],
        'command_set_field_in_other': [
            {
                view: mainSelectFormOrReportView,
                el: constants.PROP_MAIN_SELECT_FORM_OR_REPORT,
                config: {mode: 'form', modelField: 'formName'}
            },
            {
                view: mainSelectFormFieldView,
                el: constants.PROP_MAIN_SELECT_FORM_FIELD,
                config: {modelField: "formName"}
            },
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_SELECT_FORM_INSTANCE_ID,
                config: {
                    viewTitle: "App Instance ID",
                    modelField: "instanceId",
                    fieldDisplayName: "selectedInstanceFieldName"
                }
            },
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_SELECT_FORM_VALUE,
                config: {viewTitle: "Value", modelField: "default", fieldDisplayName: "selectedValueFieldName"}
            }
        ],
        'command_set_table_rows': [
            {
                view: MainSelectObject,
                el: constants.PROP_MAIN_OBJECT_STATES_VIEW,
                config: {viewTitle: 'Set Table Row Settings', label: 'Object'}
            },
            {view: MainTableActionView, el: constants.PROP_MAIN_TABLE_ACTION_VIEW}
        ],
        'command_set_properties': [
            {view: SetProperty, el: constants.PROP_MAIN_SET_PROPERTY},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_BEHAVIOR_SETTINGS,
                config: {viewTitle: "Value", modelField: "default", fieldName: "default"}
            }
        ],
        'command_transaction': [
            {view: MainTransactionView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS},
            {view: MainTypeView, el: constants.PROP_MAIN_TYPE_SETTINGS}
        ],
        'behavior_instance': [],
        'connection_arrow': [
            {view: ConnectorView, el: constants.PROP_CONNECTOR},
            {view: MainConditionView, el: constants.PROP_PATH}
        ],
        'command_run': [{view: MainSelectBehaviorView, el: constants.PROP_MAIN_BEHAVIOR_SETTINGS}],
        'control_set_filter': [
            {view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA},
            {view: MainFieldView, el: constants.PROP_MAIN_FIELD},
            {
                view: SelectValuePropertyView,
                el: constants.PROP_MAIN_FORM_INSTANCE,
                config: {viewTitle: "Value", modelField: "default"}
            },
            {view: MainChartFilterView, el: constants.PROP_MAIN_FILTER},
            {view: MainOperatorView, el: constants.PROP_MAIN_OPERATOR}

        ],
        'control_clear_filter': [{view: MainChartDataView, el: constants.PROP_MAIN_CHART_DATA}]
    };

    const behaviorSummaryRoot = {
        'command_simple_branch': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_multiple_branch': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_call_javascript': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_cancel_submission': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_cancel_notification': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_connect': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_transaction': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_connect_search': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_print': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_copy_field_values': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_check_obligatory': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show_message': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_state': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_close': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show_url': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show_page': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_get_field_from_other': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_field_in_other': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show_report': [
            {view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ],
        'command_notify': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_next_stage': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_start_stop': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_show_form': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_field_value': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_submit_data': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_table_rows': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_selection_items': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_set_properties': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'command_run': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'control_filter_selector': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'control_report_refresh': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'control_set_filter': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'control_clear_filter': [{view: MainAutoSummaryView, el: constants.PROP_MAIN_AUTO_SUMMARY}]
    };

    const workflowSettingsRoot = {
        'workflow_page': [
            {view: RolesView, el: constants.PROP_WORKFLOW_ROLES}
        ],
        'workflow_comment': [
            {view: MainCommentView, el: constants.PROP_MAIN_COMMENT}
        ],
        'connection_arrow': [
            {view: ConnectorView, el: constants.PROP_CONNECTOR},
            {view: MainConditionView, el: constants.PROP_PATH}
        ]
    };

    const workflowSummaryRoot = {
        'workflow_stage': [{view: MainStageDescriptionView, el: constants.PROP_MAIN_AUTO_SUMMARY}],
        'connection_arrow': [
            {view: MainDescriptionView, el: constants.PROP_MAIN_AUTO_SUMMARY}
        ]
    };


class PropertyViewMap {

    getAccessRoot() {
        return accessRoot;
    }

    getSettingsRoot() {
        return settingsRoot;
    }

    getAttributeRoot() {
        return attributeRoot;
    }

    getStyleRoot() {
        return styleRoot;
    }

    getMobileStyleRoot() {
        return mobileStyleRoot;
    }

    getThemeRoot() {
        return themeRoot;
    }

    getSettingsMobileRoot() {
         return settingsMobileRoot;
    }

    getSettingsTabletRoot() {
        return settingsTabletRoot;
    }

    getSettingsPhoneRoot() {
        return settingsPhoneRoot;
    }

    getSharedSettingsPhoneRoot() {
        return sharedSettingsPhoneRoot;
    }

    getSharedSettingsTabletRoot() {
        return sharedSettingsTabletRoot;
    }

    getBehaviorSettingsRoot() {
        return behaviorSettingsRoot;
    }
    getBehaviorSummaryRoot() {
        return behaviorSummaryRoot;
    }
    getWorkflowSettingsRoot() {
        return workflowSettingsRoot;
    }
    getWorkflowSummaryRoot() {
        return workflowSummaryRoot;
    }


}
const propertyViewMap = new PropertyViewMap();
export default propertyViewMap;